export const PaymentFrequencyOptions = [
  {
    label: "Per item",
    value: "per_item",
  },
  {
    label: "Per hour",
    value: "per_hour",
  },
  {
    label: "Per day",
    value: "per_day",
  },
  {
    label: "Per week",
    value: "per_week",
  },
  {
    label: "Per month",
    value: "per_month",
  },
];



// WEBPACK FOOTER //
// ./src/screens/super_products/components/Popup/components/PaymentFrequencyInput/constants.js